import axios from "axios";
import { refreshToken, logout } from "../store/authReducers";
// Create Axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
  withCredentials: true, // This ensures that the browser sends cookies
});

export const setupInterceptors = (store) => {
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 403 || error.response?.status === 401) {
        try {
          const newAccessToken = await store.dispatch(refreshToken()).unwrap();
          return axios(error.config);
        } catch (refreshError) {
          store.dispatch(logout());
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
};

export default api;
